'use client'

import { useUser as useAuth0User } from '@auth0/nextjs-auth0'

import { isVisionLocal } from '../utils/isVisionLocal'

type AuthUserResult = ReturnType<typeof useAuth0User>

const LOCAL_USER_RESULT: AuthUserResult = {
  user: undefined,
  error: undefined,
  isLoading: false,
  invalidate: async () => undefined,
}

/**
 * Returns Auth0 user data, except in Vision local mode where Auth0 is fully bypassed.
 */
export function useAuthUser(): AuthUserResult {
  if (isVisionLocal()) {
    return LOCAL_USER_RESULT
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks -- conditional hook for Vision local bypass
  return useAuth0User()
}
